exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".settings-tax .field-group .field-label {\r\n    width: 175px;\r\n}\r\n\r\n.settings-tax .field-group .form-control {\r\n    width: calc(100% - 185px);\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/components/settings/Tax.css
// module id = 625
// module chunks = 0